var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isSuperAdmin || _vm.isAdmin)?_c('admin-dashboard'):_c('user-dashboard')
}
var staticRenderFns = []

export { render, staticRenderFns }